export const C = {
  navy: '#00205B', navyLight: '#0A2E6E', navyDark: '#001440',
  lime: '#BDFF00', limeDim: '#9FD600',
  white: '#fff',
  g50: '#F8F9FC', g100: '#EEF1F6', g200: '#D8DDE8', g300: '#B0B8C9',
  g400: '#8892A6', g500: '#5F6B80', g600: '#3D4759', g700: '#2A3244',
  red: '#E53935', green: '#43A047', blue: '#1E88E5', amber: '#FB8C00',
};
